import React from 'react';

import { FlexLink } from '../../components/shared';
import { useAppContext } from '../../contexts/AppContext';
import { CommentsContextProvider, useCommentsContext } from '../../contexts/CommentsContext';
import { useComments, useCurrentUser } from '../../hooks';
import { user_dashboard_path } from '../../routes';
import { Comment as CommentType, CommentableType } from '../../utils/backend-api/comments';
import { Spinner } from '../BaseUI';
import CommentFormSection from '../Comments/CommentFormSection';
import CommentsFeed from './CommentsFeed';

// TODO: extract to new file
function CommentFormContainer({ comments }: { comments: CommentType[] }) {
  const { env } = useAppContext();
  const { currentUser } = useCurrentUser();
  const { rootCommentableId, rootCommentableType } = useCommentsContext();

  if (env.READ_ONLY_MODE) {
    return (
      <>
        {comments.length > 0 && (
          <div className="warning commenting-profile-incomplete">
            <h3>Want to comment? Please come back soon.</h3>
            Commenting is unavailable at the moment while we do necessary site maintenance. Please
            try again in 10-15 minutes.
          </div>
        )}
      </>
    );
  }

  if (currentUser?.permitted_to_comment)
    return (
      <CommentFormSection commentableId={rootCommentableId} commentableType={rootCommentableType} />
    );

  if (currentUser?.requires_name_to_comment) {
    return (
      <div className="commenting-profile-incomplete">
        Please add a name to{' '}
        <FlexLink href={user_dashboard_path()} toRailsPage>
          your profile
        </FlexLink>{' '}
        to begin commenting
      </div>
    );
  }

  return null;
}

export default function CommentsSection({
  commentableId,
  commentableType,
}: {
  commentableId: number;
  commentableType: CommentableType;
}) {
  const { comments, areCommentsLoading } = useComments(commentableId, commentableType);
  return (
    <CommentsContextProvider
      rootCommentableId={commentableId}
      rootCommentableType={commentableType}
    >
      <div className="comments comment-section">
        {areCommentsLoading || !comments ? (
          <Spinner />
        ) : (
          <div className="comment-list">
            <CommentsFeed comments={comments} />
          </div>
        )}
        <CommentFormContainer comments={comments} />
      </div>
    </CommentsContextProvider>
  );
}
